// Created by carsonaberle at 2/24/22
export const login = 'login';
export const signup = 'signup';
export const menu = 'menu';
export const profile = 'profile';
